import { render, staticRenderFns } from "./SustainfinityTable.vue?vue&type=template&id=5a2241f5&scoped=true"
import script from "./SustainfinityTable.vue?vue&type=script&lang=js"
export * from "./SustainfinityTable.vue?vue&type=script&lang=js"
import style0 from "./SustainfinityTable.vue?vue&type=style&index=0&id=5a2241f5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a2241f5",
  null
  
)

export default component.exports